/**
 * Email normalization utilities.
 * Must match the backend implementation in AccountUtils.kt::normalizeEmail()
 */

const GMAIL_DOMAIN_OLD = '@googlemail.com';
const GMAIL_DOMAIN_CURRENT = '@gmail.com';

/**
 * Normalizes an email address for comparison and storage.
 * - Trims whitespace
 * - Converts to lowercase
 * - Normalizes old googlemail.com domain to gmail.com
 *
 * @param email - The email address to normalize
 * @returns The normalized email address
 */
export function normalizeEmail(email: string): string {
  const emailLowerCase = email.trim().toLowerCase();

  // Old google mail domain (googlemail.com) is normalized to new one (gmail.com)
  if (emailLowerCase.endsWith(GMAIL_DOMAIN_OLD)) {
    return emailLowerCase.slice(0, -GMAIL_DOMAIN_OLD.length) + GMAIL_DOMAIN_CURRENT;
  }

  return emailLowerCase;
}
